module.exports = __webpack_public_path__ + "static/media/Image6.628894b6.png";